import * as React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCube  } from '@fortawesome/free-solid-svg-icons';
library.add(faCube)

export default function ShowBoxBreadcrumbs(props) {
    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            pt={3}
            separator={<NavigateNextIcon fontSize="small" />}
        >
            <Link style={{ textDecoration: 'none' }} color="primary" href="/">
            <FontAwesomeIcon style={{ color: '#1784e8', marginRight: 5 }} icon={faCube}  /> Showboxes
            </Link>
            <Typography underline="hover" color="text.primary">{props.categoryTitle.replace("the-precinct","").replace(/-/g, ' ').toUpperCase()}</Typography>
        </Breadcrumbs>
    );
}